import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FUNDAMENTO_LEGAL_REDUCAO_PIS_COFINS_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    FUNDAMENTO_LEGAL_REDUCAO_PIS_COFINS_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    FUNDAMENTO_LEGAL_REDUCAO_PIS_COFINS_ENDPOINT,
    id
  ]);
}
